export const StorageKeys = {
  // Device Keys
  USER_DEVICE_KEY: 'userDeviceKey',
  ENCRYPTED_DEVICE_KEY: 'encryptedDeviceKey',
  
  // Voucher
  VOUCHER: 'voucher',
  
  // AI Related
  AI_DONE: 'aiDone',
  AI_RAW: 'aiRaw',
} as const;

export type StorageKey = typeof StorageKeys[keyof typeof StorageKeys];